class Project {
  constructor(el) {
    this.$el = el;
    this.$popup = this.$el.querySelector('.project-popup');
    this.$popupClose = this.$popup.querySelector('.project-popup-close');
    this.$items = Array.from(this.$el.querySelectorAll('.media-container')).map(item => {
      return {
        el: item,
        w: 0,
        h: 0,
        x: {c: 0, t: 0},
        y: {c: 0, t: 0},
        scale: {c: 1, t: 1},
      }
    });
    this.zIndex = 1;
    this.threshold = 0.25;
    this.lastDown = 0;

    this.currentItem = null;
    this.render = this.render.bind(this);
    this.mouseDown = this.mouseDown.bind(this);
    this.mouseMove = this.mouseMove.bind(this);
    this.mouseUp = this.mouseUp.bind(this);
    this.touchStart = this.touchStart.bind(this);
    this.touchMove = this.touchMove.bind(this);
    this.touchEnd = this.touchEnd.bind(this);
    this.closePopup = this.closePopup.bind(this);
    
    this.$el.addEventListener('mousedown', this.mouseDown);
    document.addEventListener('mousemove', this.mouseMove);
    document.addEventListener('mouseup', this.mouseUp);

    this.$el.addEventListener('touchstart', this.touchStart, {passive: false});
    document.addEventListener('touchmove', this.touchMove, {passive: false});
    document.addEventListener('touchend', this.touchEnd, {passive: false});
    this.$popupClose.addEventListener('click', this.closePopup.bind(this));
    this.setRatios();
  }
  touchStart(e) {
    this.currentItem = this.$items.find(item => item.el === e.target.closest('.media-container'));
    if (this.currentItem) {
      this.$el.classList.add('grabbing');
      this.currentItem.el.classList.add('active');
      this.currentItem.el.style.zIndex = this.zIndex++;
      this.currentItem.scale.t = 1.1;
    }
  }
  touchMove(e) {
    if (this.currentItem) {
      let x = e.touches[0].clientX - this.currentItem.w / 2;
      let y = e.touches[0].clientY - this.currentItem.h / 2;

      if (x < this.currentItem.w * -this.threshold) {
        x = this.currentItem.w * -this.threshold;
      }
      if (y < this.currentItem.h * -this.threshold) {
        y = this.currentItem.h * -this.threshold;
      }

      if(x + this.currentItem.w > this.winW + this.currentItem.w * this.threshold) {
        x = this.winW + this.currentItem.w * this.threshold - this.currentItem.w;
      }
      if(y + this.currentItem.h > this.winH + this.currentItem.h * this.threshold) {
        y = this.winH + this.currentItem.h * this.threshold - this.currentItem.h;
      }

      this.currentItem.x.t = x;
      this.currentItem.y.t = y;
    }
  }
  touchEnd() {
    if (this.currentItem) {
      this.currentItem.el.classList.remove('active');
      this.currentItem.scale.t = 1;
      this.currentItem = null;
    }
    this.$el.classList.remove('grabbing');
  }
  mouseDown(e) {
    e.preventDefault();
    this.lastDown = Date.now();
    this.currentItem = this.$items.find(item => item.el === e.target.closest('.media-container'));
    if (this.currentItem) {
      this.$el.classList.add('grabbing');
      this.currentItem.el.classList.add('active');
      this.currentItem.el.style.zIndex = this.zIndex++;
      this.currentItem.scale.t = 1.1;
    }
  }
  mouseMove(e) {
    e.preventDefault();
    if (this.currentItem) {
      let x = e.clientX - this.currentItem.w / 2;
      let y = e.clientY - this.currentItem.h / 2;

      if (x < this.currentItem.w * -this.threshold) {
        x = this.currentItem.w * -this.threshold;
      }
      if (y < this.currentItem.h * -this.threshold) {
        y = this.currentItem.h * -this.threshold;
      }

      if(x + this.currentItem.w > this.winW + this.currentItem.w * this.threshold) {
        x = this.winW + this.currentItem.w * this.threshold - this.currentItem.w;
      }
      if(y + this.currentItem.h > this.winH + this.currentItem.h * this.threshold) {
        y = this.winH + this.currentItem.h * this.threshold - this.currentItem.h;
      }

      this.currentItem.x.t = x;
      this.currentItem.y.t = y;
    }
  }
  mouseUp(e) {
    if (this.currentItem) {
      this.currentItem.el.classList.remove('active');
      this.currentItem.scale.t = 1;
    }
    this.$el.classList.remove('grabbing');
    if (Date.now() - this.lastDown < 180) {
      const item = this.currentItem;
      this.openItem(item);
    }
    this.currentItem = null;
  }
  openItem(item) {
    if(!item) return;
    const isVideo = item.el.querySelector('video');
    this.$popup.classList.toggle('is-video', isVideo);
    if (isVideo) {
      const src = item.el.querySelector('video').currentSrc;
      this.$popup.querySelector('video').src = src
    }else {
      this.$popup.querySelector('img').src = item.el.querySelector('img').src;
    }
    this.$popup.classList.toggle('is-portrait', item.el.getAttribute('data-ratio') >= 1);
    this.$popup.classList.add('active');
  }
  closePopup() {
    this.$popup.classList.remove('active');
    this.$items.forEach(item => {
      const video = item.el.querySelector('video');
      if (video) video.play();
    });
    this.$popup.querySelector('video').pause();
    if(this.closePopupTO) clearTimeout(this.closePopupTO);
    this.closePopupTO = setTimeout(() => {
      this.$popup.querySelector('video').src = '';
      this.$popup.querySelector('img').src = '';
    }, 900);
  }
  setRatios() {
    Promise.all(this.$items.map(item => {
      return new Promise(resolve => {
        
        const isVideo = item.el.querySelector('video');
        if (isVideo) {
          const video = item.el.querySelector('video');
          video.onloadeddata = () => {
            resolve();
          };
          if (video.readyState > 3) {
            resolve();
          }
        } else if (item.el.querySelector('img')) {
          const img = item.el.querySelector('img');
          img.onload = () => {
            resolve();
          };
          if (img.complete) {
            resolve();
          }
        }
      })
    })).then(() => {
      this.init();
    });
    setTimeout(() => {
      if (!this.inited) this.init();
    }, 5000);
  }
  resize() {
  this.isMobile = window.innerWidth <= 580;
  this.maxW = 0.2;
  this.threshold = 0.25;
  if (this.isMobile) {
    this.maxW = 0.4;
    this.threshold = 0.5;
  }

  this.winW = window.innerWidth;
  // lienzo más alto para que haya espacio vertical
  this.winH = window.innerHeight * 3;

  // rectángulo del bloque de texto (.project-content)
  const contentEl = this.$el.querySelector('.project-content');
  const contentRect = contentEl ? contentEl.getBoundingClientRect() : null;

  this.$items.forEach((item, index) => {
    const w =
      (Math.random() * (this.maxW - this.maxW * 0.9) + this.maxW * 0.9) *
      this.winW;
    const ratio = item.el.offsetHeight / item.el.offsetWidth;
    const h = w * ratio;
    item.el.setAttribute('data-ratio', ratio);
    item.el.style.width = `${w}px`;

    let x =
      Math.random() * (this.winW + w * this.threshold) - w * this.threshold;
    let y =
      Math.random() * (this.winH + h * this.threshold) - h * this.threshold;

    // límites generales
    if (x < w * -this.threshold) {
      x = w * -this.threshold;
    }
    if (y < h * -this.threshold) {
      y = h * -this.threshold;
    }

    if (x + w > this.winW + w * this.threshold) {
      x = this.winW + w * this.threshold - w;
    }
    if (y + h > this.winH + h * this.threshold) {
      y = this.winH + h * this.threshold - h;
    }

    // 👉 evitar que nazcan encima del bloque de texto
    if (contentRect) {
      const overlapHoriz = x < contentRect.right && x + w > contentRect.left;
      const overlapVert = y < contentRect.bottom && y + h > contentRect.top;

      if (overlapHoriz && overlapVert) {
        // empujar la imagen a la derecha del texto
        x = contentRect.right + 40;

        // asegurar que no se salga del borde derecho
        if (x + w > this.winW + w * this.threshold) {
          x = this.winW + w * this.threshold - w;
        }
      }
    }

    item.w = w;
    item.h = h;
    item.x.c = this.winW / 2 - w / 2;
    item.y.c = this.winH / 2 - h / 2;
    item.x.t = x;
    item.y.t = y;
  });
}

  init() {
    this.inited = true;
    this.resize();
    this.render();
    this.$el.classList.add('loaded');
  }
  render() {
    this.$items.forEach(item => {
      item.x.c += (item.x.t - item.x.c) * 0.1;
      item.y.c += (item.y.t - item.y.c) * 0.1;
      item.scale.c += (item.scale.t - item.scale.c) * 0.1;
      item.el.style.transform = `translate3d(${item.x.c}px, ${item.y.c}px, 0) scale(${item.scale.c})`;
    });
    requestAnimationFrame(this.render);
  }
}